import { AfterViewInit, Directive, ElementRef, OnDestroy } from '@angular/core';
import { FrontendModalService } from '@tablesready/frontend-modal';
import { filter, Subscription, take } from 'rxjs';

@Directive({
  selector: '[modalHeader]',
  standalone: false,
})
export class FrontendModalHeaderDirective implements AfterViewInit, OnDestroy {
  private readonly subscription = new Subscription();

  constructor(
    private readonly el: ElementRef,
    private readonly service: FrontendModalService,
  ) { }

  ngAfterViewInit(): void {
    const modalSub = this.service.modalWithIdPresented$
      .pipe(
        filter(data => data !== null),
      )
      .subscribe(() => {
        const height = this.el.nativeElement.offsetHeight;
        this.service.setHeader(height);
      });
    this.subscription.add(modalSub);
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
